import HttpServiceBasic from 'services/HttpServiceBasic';
const COOKIE_NAME = 'lv';
const AB_TEST_XHR_URL = '/abtests/xhr/';

export default class AbTestHttpService extends HttpServiceBasic {
    constructor({ isAA = false } = {}) {
        super();
        this.isAA = isAA;
        this.state = {}; // for access to vuex store state
        this.xhrUrl = '';
        this.setDefaultXhrUrl();
    }

    setDefaultXhrUrl(url = null) {
        this.xhrUrl = url ?? (this.isAA ? `/account/xhr` : '') + AB_TEST_XHR_URL;
        return this;
    }

    setState(state) {
        this.state = state;
        return this;
    }

    getVariantForTest(testName) {
        const testNamesObject = [testName];
        return this.getVariantMultipleTests(testNamesObject);
    }

    getVariantMultipleTests(testNamesObject) {
        return new Promise((resolve, reject) => {
            if (typeof testNamesObject === 'object' && Object.keys(testNamesObject).length === 0) {
                reject('no values to set');
            }

            testNamesObject.filter((testName) => {
                // resolve with variant in store state without having to load from API
                if (this.stateHasVariant(testName)) {
                    return false;
                }

                // TODO test this code against Cypress XHR Tests

                // resolve with variant in cookie without having to load from API
                const cookieVariant = this.getCookieVariant(testName);
                if (cookieVariant) {
                    testVariants.push(this.getSuccessResp(cookieVariant[testName]));
                    return false;
                }
            });

            // for each test if no variant was found from the cookie or in state,
            // then call xhr url requests to get variants
            if (this.xhrUrl) {
                let fullXhrUrl = `${this.xhrUrl}?tests[]=${testNamesObject.join('&tests[]=')}`;

                this.doGet(fullXhrUrl)
                    .then((data) => {
                        resolve(data);
                    })
                    .catch((e) => {
                        reject(e);
                    });
            }
        });
    }

    getVariantForExperiments() {
        return this.doGet(this.xhrUrl)
            .then((res) => {
                return res;
            })
            .catch((err) => {
                throw new Error(err);
            });
    }

    setVariantCookie(test, variant) {
        return new Promise((resolve, reject) => {
            if (this.xhrUrl) {
                const setCookieUrl = `${this.xhrUrl}set-variant-cookie/?urlOverrideTest=${test}&urlOverrideVariant=${variant}`;
                this.doGet(setCookieUrl)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((e) => {
                        reject(e);
                    });
            } else {
                reject('missing xhrUrl in setVariantCookie');
            }
        });
    }

    getSuccessResp(variant) {
        return {
            success: true,
            variant: variant,
        };
    }

    stateHasVariant(testName) {
        return this.state.variant ? this.state.variant.hasOwnProperty(testName) : false;
    }

    getCookieVariant(testName) {
        const loadedVariants = this.readVariantFromCookie();
        return loadedVariants.hasOwnProperty(testName) ? loadedVariants : false;
    }

    readVariantFromCookie() {
        let loadedVariants = {};
        const cookieValue = this.getVariantCookieValue();

        if (cookieValue.length > 0) {
            loadedVariants = JSON.parse(unescape(cookieValue));
        }
        return loadedVariants;
    }

    getVariantCookieValue() {
        const b = document.cookie.match('(^|;)\\s*' + COOKIE_NAME + '\\s*=\\s*([^;]+)');
        return b ? b.pop() : '';
    }
}
